exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n#navbar-content-container[data-v-2d2cbed3] {\n  margin-left: var(--marginLeftContent);\n}\n@media (max-width: 1151px) {\n#navbar-content-container[data-v-2d2cbed3] {\n    margin-left: 0;\n}\n}\n", ""]);
